import React, { useContext } from "react";
import { PlayerAction } from "../../../types";
import Waitable from "../../common/waitable/waitable";
import { GameStatus } from "../../../types/game-status";
import FormPage from "../../common/formpage/formpage";
import { useTranslation } from "react-i18next";
import { useWaitableForm } from "../../../hooks/useWaitableForm";
import OtpSubmitBase from "./otp-submit-base";
import { useOtpSubmit } from "./useOtpSubmit";
import { GameContext } from "../../../contexts";

const OtpSubmit = () => {
  const { t } = useTranslation(["game", "common"]);
  const { submit } = useContext(GameContext);

  const {
    playerCharacters,
    characters,
    mature,
    isSolo,
    isAllAges,
    subHeaders,
    submitText,
    titles,
    handleChange,
    handleMature,
    createPlayerAction,
    isReady,
  } = useOtpSubmit();

  const showMaturitySelector = !isAllAges && !isSolo;

  const { waitableProps, formPageProps } = useWaitableForm({
    gameSubmit: createPlayerAction,
    waitingFor: [GameStatus.GameStatusPostCharacters],
    waitHeader: t("createStory.headers.waiting"),
    titles,
    submitText,
    validation: { isReady },
    subHeaders,
  });

  return (
    <Waitable playerActionHandler={submit} {...waitableProps}>
      <FormPage {...formPageProps}>
        <OtpSubmitBase
          playerCharacters={playerCharacters}
          characterNames={characters}
          onNameChange={handleChange}
          showMaturitySelector={showMaturitySelector}
          mature={mature}
          onMatureChange={handleMature}
          maturityLabelText={t("createStory.body.maturity")}
          eighteenPlusText={t("label.eighteenPlus", { ns: "common" })}
          allAgesText={t("label.allAges", { ns: "common" })}
        />
      </FormPage>
    </Waitable>
  );
};
export default OtpSubmit;
